import { useEffect, useRef } from 'react';

import type { DigizuiteAsset } from 'models/asset';
import { ignorePromiseRejection } from 'utils/helpers';

interface Props {
	asset: Omit<DigizuiteAsset, 'formatName'>;
	className?: string;
	isPlaying?: boolean;
	loading?: 'eager' | 'lazy';
}

/** A looping, muted video that is hidden from assistive technologies. */
export default function DecorativeVideo({
	asset,
	className,
	isPlaying = true,
	loading = 'lazy',
}: Props) {
	const videoRef = useRef<HTMLVideoElement>(null);

	useEffect(() => {
		if (isPlaying && videoRef.current) {
			ignorePromiseRejection(videoRef.current.play());
		} else if (videoRef.current) {
			videoRef.current.pause();
		}
	}, [isPlaying]);

	return (
		<video
			ref={videoRef}
			autoPlay
			loop
			muted
			playsInline
			aria-hidden="true"
			tabIndex={-1}
			// @ts-expect-error No types for `loading` on video yet.
			loading={loading}
			className={className}
		>
			<source type={asset.contentType} src={asset.src} />
		</video>
	);
}
DecorativeVideo.displayName = 'DecorativeVideo';
